// #region import
import { SET_APPS } from './mutations'
// #endregion

// #region store
export default {
  namespaced: true,
  // #region state
  state: {
    apps: [],
  },
  // #endregion
  // #region getters
  getters: {
    dashboards(state) {
      let dashboards = []
      for (let app of state.apps) {
        for (let dashboard of app.dashboards) {
          dashboards.push(dashboard)
        }
      }
      return dashboards
    },
  },
  // #endregion
  // #region mutations
  mutations: {
    [SET_APPS](state, payload) {
      state.apps = payload
    },
  },
  // #endregion
  // #region actions
  actions: {
    /**
     * Initialize the Module.
     * @async
     */
    initializeModule({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        return (
          dispatch(
            'firestore/getDocs',
            {
              path: '_apps', //TODO - remove hardcoded app document, make a collection called "_instance" with an array of apps
            },
            { root: true }
          )
            // .then((document) => {
            //   return dispatch('populateDocument', { document: document, maxDepth: 2 }, { root: true })
            //   return Promise.all(
            //     document.dashboards.map((value) => {
            //       return dispatch(
            //         'firestore/getDoc',
            //         {
            //           path: value.path,
            //         },
            //         { root: true }
            //       )
            //     })
            //   )
            // })
            .then((documents) => {
              return Promise.all(
                documents.map((value) => {
                  return dispatch('populateDocument', { document: value, maxDepth: 2 }, { root: true })
                })
              )
            })
            .then((documents) => {
              commit('SET_APPS', documents)
              resolve()
            })
            .catch((error) => {
              console.log('err', error)
              reject(error)
            })
        )
      })
    },
  },
  // #endregion
  // #region modules
  modules: {},
  // #endregion
}
// #endregion
